import { useEffect, useState } from 'react';

/**
 * Devuelve el `data-testid` de la seccion actualmente mas visible en el viewport.
 * Reutilizado por TOC y ProgressBar para mantener un highlight sincronizado.
 *
 * @param {string[]} sectionIds  Lista de data-testid a observar (en orden del documento).
 */
export default function useActiveSection(sectionIds = []) {
  const [activeId, setActiveId] = useState(sectionIds[0] || null);

  useEffect(() => {
    if (!sectionIds || sectionIds.length === 0) return undefined;
    const targets = sectionIds
      .map((id) => document.querySelector(`[data-testid="${id}"]`))
      .filter(Boolean);
    if (targets.length === 0) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) {
          const id = visible.target.getAttribute('data-testid');
          if (id) setActiveId(id);
        }
      },
      { rootMargin: '-30% 0px -55% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] }
    );
    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, [sectionIds.join('|')]); // eslint-disable-line react-hooks/exhaustive-deps

  return activeId;
}
